import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { TrustLogos } from './components/TrustLogos';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { Urgency } from './components/Urgency';
import { LeadForm } from './components/LeadForm';
import { Footer } from './components/Footer';
import { initPixel, trackPageView } from './utils/pixel';
export function App() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-light-bg font-sans selection:bg-vitality-green selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <SocialProof data-id="element-3" />
        <TrustLogos data-id="element-4" />
        <Benefits data-id="element-5" />
        <Testimonials data-id="element-6" />
        <Urgency data-id="element-7" />
        <LeadForm data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}